let url = '/v1/admin/membership';
export const MEMBERSHIP_ENDPOINT = {
  getMembership: {
    url,
    method: 'GET',
  },
  getMembershipHistory: {
    url:`/v1/membership/history`,
    method: 'GET',
  },
  addMembership: {
    url: url,
    method: 'POST',
  },
  editMembership: (id) => ({
    url: `${url}/${id}`,
    method: 'PUT',
  }),
  getMembershipDetails: (id) => ({
    url: `${url}/${id}`,
    method: 'GET',
  }),
  cancelMembershipPlan: (id) => ({
    url: `/v1/membership/cancel/${id}`,
    method: 'PUT',
  }),
  membershipStatusUpdate: {
    url: `${url}/change-status`,
    method: 'PUT',
  },
  deleteMembership: {
    url,
    method: 'DELETE',
  },
  settlePayment: (id) => ({
    url: `/v1/membership/history/${id}`,
    method: 'PUT',
  }),
  getMembershipHistoryAmountDetails: {
    url:'/v1/membership/history-calculation',
    method: 'GET',
  },
  sendRecieptEmail:(id)=>({
    url:`/v1/membership/receipt/${id}`,
    method: 'GET',
  }),
  updateMarkAsSettled: {
    url: 'v1//membership/history',
    method: 'PUT',
  },
};
